
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/transportbil/mercedes-sprinter",
      function () {
        return require("private-next-pages/tyres/transportbil/mercedes-sprinter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/transportbil/mercedes-sprinter"])
      });
    }
  